import { ComponentPropsWithRef } from "react";
import styled from "styled-components";
import { shade0, shade700, shade900 } from "../../../styles/tokens";
import { IconButton as IconButtonComp } from "../../icon-button/IconButton.Parts";

// TEXT

// STYLES
export const IconButton = styled(IconButtonComp)`
  z-index: 1;
  position: relative;
  border-radius: 3rem;

  color: ${shade700};
  background-color: ${shade900};

  &:hover:not([disabled]) {
    color: ${shade0};
  }
`;

// DATA

// TYPES
export type Props = Omit<ComponentPropsWithRef<"button">, "children"> & {
  $muted?: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
